import { DataTableValue } from "primereact/datatable"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { ToastContent, toast } from "react-toastify"
import { handleLoader } from "redux/counterSlice"
import { getGroupsListService } from "services/groupService"

const useFetchGroupList = (): [DataTableValue[], () => Promise<void>] => {
	const [groupList, setGroupList] = useState<DataTableValue[]>([])
	const dispatch = useDispatch();
	const fetchGroupList = async () => {
		dispatch(handleLoader(true));
		try {
			// NOTE: Integrate the API and add the data to state
			const { response, error } = await getGroupsListService()
			if (error) {
				throw error
			}
			if ((response as any)?.error) {
				throw (response as any)?.error
			}
			dispatch(handleLoader(false));
			setGroupList(response as DataTableValue[])
		} catch (error) {
			dispatch(handleLoader(false));
			toast.error(error as ToastContent<unknown>, {
				style: {
					backgroundColor: '#F1F1F1', // Grey background
				}
			})
		}
	}

	useEffect(() => {
		fetchGroupList()
	}, [])

	return [groupList, fetchGroupList]
}

export default useFetchGroupList
